import ack from '@audit/finding-ack';
export const { findingEvidenceKey, matchingAck, isResolvedAck, ackEvidence, isRetiredFinding, withSavedFindingEvidence } = ack;
